module.exports = __webpack_public_path__ + "img/arrow.f71dc785.svg";